<template>
 <div class="csoportgyakorlatok">
     <v-app id="csoportgyakorlatok">
                 <h1 class="text-center">Témakörök</h1>
                   <v-simple-table>
                     <template v-slot:default>
                       <thead>
                         <th class="text-center">Témakör</th>
                         <th class="text-center">Törlés</th>
                       </thead>
                       <tbody>
                         <tr v-for="temakor in csoport.temakorok" :key="csoport.temakorok.id">
                           <td class="text-center">{{temakor.nev}}</td>
                           <td class="text-center">
                             <v-btn
                               v-if="temakor.id>-1"
                               color="red"
                               @click="temakortorlese(temakor.id)"
                               rounded
                             >
                               Törlés
                               <v-icon>fa-trash</v-icon>
                             </v-btn>
                           </td>
                         </tr>
                         <tr>
                           <td colspan="2">
                             <v-row>
                               <v-col
                                 cols="12"
                                 md="10"
                               >
                                 <v-text-field
                                   label="Új témakör"
                                   v-model="ujtemakor"
                                 ></v-text-field>
                               </v-col>
                               <v-col
                                 cols="12"
                                 md="2"
                               >
                                 <v-btn
                                   color="success"
                                   @click="temakorhozzaadasa()"
                                   rounded
                                 >
                                   Hozzáadás
                                   <v-icon>fa-plus</v-icon>
                                 </v-btn>
                               </v-col>
                             </v-row>
                           </td>
                         </tr>
                       </tbody>
                     </template>
                   </v-simple-table>
                 <h1 class="text-center">Gyakorlatok</h1>
                 <v-simple-table ref="gyakorlatok">
                   <template v-slot:default>
                     <thead>
                       <tr>
                         <th colspan="4"></th>

                         <th colspan="4" class="text-center">Követelmény</th>
                       </tr>
                       <tr>
                         <th class="text-center">Gyakorlat</th>
                         <th class="text-center">Témakör</th>
                         <th class="text-center">Típus</th>
                         <th class="text-center">Növekvő</th>
                         <th class="text-center">5</th>
                         <th class="text-center">4</th>
                         <th class="text-center">3</th>
                         <th class="text-center">2</th>
                         <th class="text-center">Leírás</th>
                         <th class="text-center">Törlés</th>
                       </tr>

                     </thead>
                     <tbody>
                       <tr v-for="(gyakorlat, index) in csoport.gyakorlatok" v-if="gyakorlat.temakor!=-2" v-bind:key="csoport.gyakorlatok.id">
                         <td class="text-center"> {{gyakorlat.nev}} </td>
                         <td class="text-center">
                           <v-select :items="csoport.temakorok" v-model="csoport.gyakorlatok[index].temakor" label="Témakör" item-text="nev" item-value="id" v-on:change="gyakorlatfrissitese(gyakorlat.id, 'temakor', $event)"></v-select>
                         </td>
                         <td>
                           <v-select :items="tipus" v-model="csoport.gyakorlatok[index].tipus"  label="Típus"
                            v-on:change="gyakorlatfrissitese(gyakorlat.id, 'novekvo', $event)"></v-select>
                         </td>
                         <td>
                           <v-select :items="novcsok"  v-model="csoport.gyakorlatok[index].novekvo"  label="Növekvő"
                            v-on:change="gyakorlatfrissitese(gyakorlat.id, 'novekvo', $event)"></v-select>
                         </td>
                         <td class="text-center">
                           <v-col>
                             <v-row>
                               <v-text-field
                                 label="Követelmény - 5 - Fiú"
                                 prepend-inner-icon="fa-mars"
                                 color="blue"
                                 v-on:change="gyakorlatfrissitese(gyakorlat.id, 'fkovetelmeny5', $event)"
                                 v-model="csoport.gyakorlatok[index].fkovetelmeny5"
                               ></v-text-field>
                             </v-row>
                             <v-row>
                               <v-text-field
                                 label="Követelmény - 5 - Lány"
                                 prepend-inner-icon="fa-venus"
                                 color="pink"
                                 v-on:change="gyakorlatfrissitese(gyakorlat.id, 'lkovetelmeny5', $event)"
                                 v-model="csoport.gyakorlatok[index].lkovetelmeny5"
                               ></v-text-field>
                             </v-row>
                           </v-col>

                         </td>
                         <td class="text-center">
                           <v-col>
                             <v-row>
                               <v-text-field
                                 label="Követelmény - 4 - Fiú"
                                 prepend-inner-icon="fa-mars"
                                 color="blue"
                                 v-on:change="gyakorlatfrissitese(gyakorlat.id, 'fkovetelmeny4', $event)"
                                 v-model="csoport.gyakorlatok[index].fkovetelmeny4"
                               ></v-text-field>
                             </v-row>
                             <v-row>
                               <v-text-field
                                 label="Követelmény - 4 - Lány"
                                 prepend-inner-icon="fa-venus"
                                 color="pink"
                                 v-on:change="gyakorlatfrissitese(gyakorlat.id, 'lkovetelmeny4', $event)"
                                 v-model="csoport.gyakorlatok[index].lkovetelmeny4"
                               ></v-text-field>
                             </v-row>
                           </v-col>

                         </td>
                         <td class="text-center">
                           <v-col>
                             <v-row>
                               <v-text-field
                                 label="Követelmény - 3 - Fiú"
                                 prepend-inner-icon="fa-mars"
                                 color="blue"
                                 v-on:change="gyakorlatfrissitese(gyakorlat.id, 'fkovetelmeny3', $event)"
                                 v-model="csoport.gyakorlatok[index].fkovetelmeny3"
                               ></v-text-field>
                             </v-row>
                             <v-row>
                               <v-text-field
                                 label="Követelmény - 3 - Lány"
                                 prepend-inner-icon="fa-venus"
                                 color="pink"
                                 v-on:change="gyakorlatfrissitese(gyakorlat.id, 'lkovetelmeny3', $event)"
                                 v-model="csoport.gyakorlatok[index].lkovetelmeny3"
                               ></v-text-field>
                             </v-row>
                           </v-col>

                         </td>
                         <td class="text-center">
                           <v-col>
                             <v-row>
                               <v-text-field
                                 label="Követelmény - 2 - Fiú"
                                 prepend-inner-icon="fa-mars"
                                 color="blue"
                                 v-on:change="gyakorlatfrissitese(gyakorlat.id, 'fkovetelmeny2', $event)"
                                 v-model="csoport.gyakorlatok[index].fkovetelmeny2"
                               ></v-text-field>
                             </v-row>
                             <v-row>
                               <v-text-field
                                 label="Követelmény - 2 - Lány"
                                 prepend-inner-icon="fa-venus"
                                 color="pink"
                                 v-on:change="gyakorlatfrissitese(gyakorlat.id, 'lkovetelmeny2', $event)"
                                 v-model="csoport.gyakorlatok[index].lkovetelmeny2"
                               ></v-text-field>
                             </v-row>
                           </v-col>

                         </td>
                         <td>
                             <v-textarea
                               label="Leírás"
                               auto-grow
                               filled
                               solo
                               v-on:change="gyakorlatfrissitese(gyakorlat.id, 'leiras', $event)"
                               v-model="csoport.gyakorlatok[index].leiras"></v-textarea>
                         </td>
                         <td class='text-center'>
                           <v-btn
                             color="red"
                             rounded
                             @click="gyakorlattorlese(gyakorlat.id,csoport.gyakorlatok.findIndex(gyakorlatK => { return gyakorlatK.id===gyakorlat.id}))"
                           >Törlés<v-icon>fa-trash</v-icon></v-btn>
                         </td>
                       </tr>
                       <tr>
                         <td colspan="9"><v-form ref="gyakorlathozzaadasa"
                                 lazy-validation
                           >
                             <v-container>
                               <v-row>
                                 <v-col
                                   align-self="center"
                                   cols="16"
                                   md="2"
                                 >
                                   <v-text-field
                                     v-model="ujgyakorlat.nev"
                                     label="Új gyakorlat neve"
                                     required
                                     prepend-inner-icon="fa-dumbbell"
                                   ></v-text-field>
                                 </v-col>
                                 <v-col
                                   align-self="center"
                                   cols="16"
                                   md="2"
                                 >
                                   <v-select
                                     :items="csoport.temakorok" label="Témakör" v-model="ujgyakorlat.temakor" item-value="id" item-text="nev"
                                   ></v-select>
                                 </v-col>
                                 <v-col
                                   align-self="center"
                                     cols="16"
                                     md="2"
                                   >
                                 <v-select :items="tipus" label="Típus" v-model="ujgyakorlat.tipus"
                                    ></v-select>
                                 </v-col>
                                 <v-col
                                   align-self="center"
                                   cols="16"
                                   md="2"
                                   >
                                   <v-select label="Növekvő" :items="novcsok" v-model="ujgyakorlat.novekvo"></v-select>
                                   </v-col>
                                   <v-col
                                     cols="16"
                                     md="1"
                                   >
                                   <v-row>
                                     <v-text-field
                                       v-model.number="ujgyakorlat.fkovetelmeny5"
                                       label="Követelmény - 5 - Fiú"
                                       prepend-inner-icon="fa-mars"
                                       color="blue"
                                       required
                                     ></v-text-field>
                                   </v-row>
                                   <v-row>
                                     <v-text-field
                                       v-model.number="ujgyakorlat.lkovetelmeny5"
                                       label="Követelmény - 5 - Lány"
                                       prepend-inner-icon="fa-venus"
                                       color="pink"
                                       required
                                     ></v-text-field>
                                   </v-row>
                                 </v-col>
                                 <v-col
                                   cols="16"
                                   md="1"
                                 >
                                   <v-row>
                                     <v-text-field
                                       v-model.number="ujgyakorlat.fkovetelmeny4"
                                       label="Követelmény - 4 - Fiú"
                                       prepend-inner-icon="fa-mars"
                                       color="blue"
                                       required
                                     ></v-text-field>
                                   </v-row>
                                   <v-row>
                                     <v-text-field
                                       v-model.number="ujgyakorlat.lkovetelmeny4"
                                       label="Követelmény - 4 - Lány"
                                       prepend-inner-icon="fa-venus"
                                       color="pink"
                                       required
                                     ></v-text-field>
                                   </v-row>
                                 </v-col>
                                 <v-col
                                   cols="16"
                                   md="1"
                                 >
                                   <v-row>
                                     <v-text-field
                                       v-model.number="ujgyakorlat.fkovetelmeny3"
                                       label="Követelmény - 3 - Fiú"
                                       prepend-inner-icon="fa-mars"
                                       color="blue"
                                       required
                                     ></v-text-field>
                                   </v-row>
                                   <v-row>
                                     <v-text-field
                                       v-model.number="ujgyakorlat.lkovetelmeny3"
                                       label="Követelmény - 3 - Lány"
                                       prepend-inner-icon="fa-venus"
                                       color="pink"
                                       required
                                     ></v-text-field>
                                   </v-row>
                                 </v-col>
                                 <v-col
                                   cols="16"
                                   md="1"
                                 >
                                   <v-row>
                                     <v-text-field
                                       v-model.number="ujgyakorlat.fkovetelmeny2"
                                       label="Követelmény - 2 - Fiú"
                                       prepend-inner-icon="fa-mars"
                                       color="blue"
                                       required
                                     ></v-text-field>
                                   </v-row>
                                   <v-row>
                                     <v-text-field
                                       v-model.number="ujgyakorlat.lkovetelmeny2"
                                       label="Követelmény - 2 - Lány"
                                       prepend-inner-icon="fa-venus"
                                       color="pink"
                                       required
                                     ></v-text-field>
                                   </v-row>
                                 </v-col>
                                 <v-col
                                   cols="16"
                                   md="2"
                                 >

                                   <v-textarea
                                     v-model="ujgyakorlat.leiras"
                                     label="Leírás"
                                     auto-grow
                                     filled
                                     solo
                                   ></v-textarea>
                                 </v-col>
                                 <v-col
                                   cols="16"
                                   md="2"
                                 >
                                   <v-btn
                                     color="success"
                                     @click="ujGyakorlat()"
                                     rounded
                                   >
                                     Létrehozás
                                     <v-icon>fa-plus</v-icon>
                                   </v-btn>
                                 </v-col>
                             </v-row>
                         </v-container>
                           </v-form></td>

                       </tr>
                     </tbody>
                   </template>
                 </v-simple-table>
                 <router-link :to="{ name: 'csoportjegyek', params: {id: id} }" v-if="!csoport.sablon"><v-fab-transition><v-btn color="blue" bottom left fixed fab><v-icon>fa-star</v-icon></v-btn></v-fab-transition></router-link>

                 <router-link :to="{ name: 'csoporteredmenybevitel', params: {id: id} }" v-if="!csoport.sablon"><v-fab-transition><v-btn color="lime" bottom right fixed fab><v-icon>fa-keyboard</v-icon></v-btn></v-fab-transition></router-link>
       <v-snackbar
         v-model="snackbar.megnyit"
       >
         {{ snackbar.szoveg }}
         <v-btn
           color="pink"
           text
           @click="snackbar.megnyit = false"
         >
           Bezár
         </v-btn>
       </v-snackbar>
     </v-app>
 </div>

</template>

<script>
/*import axios from 'axios'
axios.defaults.withCredentials = true*/


    import router from "../router"

export default {
 props: ['id'],
 components: {
 },
 data: function () {
   return {

     csoport: {},
     novcsok: [{ text: '5-ös felé növekvő', value: 1 }, { text: '5-ös felé csökkenő', value: 0 }],
     tipus: [{ text: 'Egyszerű', value: 0 }, {text: "Perc-Másodperc", value: 1} ],
     snackbar: {
       megnyit: false,
       szoveg: 'Nem számot adott meg!'
     },
     ujgyakorlat: {
       nev: '',
       temakor: -1,
       tipus: 0,
       novekvo: 0,
       fkovetelmeny5: 5,
       fkovetelmeny4: 4,
       fkovetelmeny3: 3,
       fkovetelmeny2: 2,
       lkovetelmeny5: 5,
       lkovetelmeny4: 4,
       lkovetelmeny3: 3,
       lkovetelmeny2: 2,
       leiras:''
     },
     ujtemakor: '',
   }
 },
 computed: {
 },
 methods: {
   kijelentkezes: function() {
           this.$store.commit('bejelentkezve', false)
           router.push('/bejelentkezes');
           this.$store.commit('admin',false)
   },
   temakorhozzaadasa: function () {
     if (this.ujtemakor != '') {
       this.axios
         .post(this.$store.state.backendeleres+'csoportok/csoport/' + this.id + '/temakorok', { nev: this.ujtemakor })
         .then(response => {
           if (response.data.ok) {
             this.csoport.temakorok.push({ id: response.data.id, nev: response.data.nev })
           }
           this.ujtemakor = ''
           if(response.data.bejelentkezve==false){
             this.kijelentkezes();
           }
         })
     } else {
       this.snackbar.szoveg = 'Adja meg az új témakör nevét!'
       this.snackbar.megnyit = true
     }
   },
   temakortorlese: function (temakorid) {
     this.axios
       .delete(this.$store.state.backendeleres+'csoportok/temakorok/' + temakorid)
       .then(response => {
         if (response.data.ok) {
           this.csoport.temakorok.splice(this.csoport.temakorok.findIndex(
               temakor => {
                 return temakor.id == temakorid
               }
             ), 1)
           for (var i = 0; i < this.csoport.gyakorlatok.length; i++) {
             if (this.csoport.gyakorlatok[i].temakor == temakorid) {
               this.csoport.gyakorlatok[i].temakor = -1
             }
           }
           if (this.megjelenitendotemakor == temakorid) {
             this.megjelenitendotemakor = -1
           }
         }
         if(response.data.bejelentkezve==false){
             this.kijelentkezes();
         }
       })
   },
   csoportfrissitese: function () {
     this.axios
       .get(this.$store.state.backendeleres+'csoportok/csoport/' + this.id)
       .then(response => {this.csoport = response.data;
         if(response.data.bejelentkezve==false){
             this.kijelentkezes();
           }
       })
   },
   gyakorlatfrissitese: function (gyakorlatid, mezo, esemeny) {
     var gyakorlat = this.csoport.gyakorlatok.find(({ id }) => id === gyakorlatid)
     var helyesertek=!isNaN(esemeny);
     if(mezo=="leiras"){
       helyesertek=true;
     }
     if (helyesertek) {
       var gyakorlatmasolat = this.objektumatadas(gyakorlat)
       gyakorlatmasolat[mezo] = esemeny
     this.axios
       .put(this.$store.state.backendeleres+'csoportok/gyakorlat/' + gyakorlat.id, gyakorlatmasolat)
       .then(response => {
         if (response.data.ok) {
           gyakorlat[mezo] = esemeny
           this.snackbar.szoveg = 'Mentve'
           this.snackbar.megnyit = true
         } else {
           this.snackbar.szoveg = response.data.hiba
           this.snackbar.megnyit = true
           gyakorlat = response.data.eredetigyakorlat
         }
         if(response.data.bejelentkezve==false){
             this.kijelentkezes();
           }
       })
     } else {
       this.snackbar.szoveg = 'Nem számot adott meg!'
       this.snackbar.megnyit = true
       this.axios
         .get(this.$store.state.backendeleres+'csoportok/gyakorlat/'+gyakorlatid+'/'+mezo)
         .then(response => {
           gyakorlat[mezo]=response.data.mezo;
           if(response.data.bejelentkezve==false){
             this.kijelentkezes();
           }
         })
     }
   },
   ujGyakorlat: function () {
     if (this.ujgyakorlat.nev != '' && this.ujgyakorlat.fkovetelmeny5 != '' && !isNaN(this.ujgyakorlat.fkovetelmeny5) && this.ujgyakorlat.fkovetelmeny4 != '' && !isNaN(this.ujgyakorlat.fkovetelmeny4) && this.ujgyakorlat.fkovetelmeny3 != '' && !isNaN(this.ujgyakorlat.fkovetelmeny3) && this.ujgyakorlat.fkovetelmeny2 != '' && !isNaN(this.ujgyakorlat.fkovetelmeny2)) {
       this.axios
         .post(this.$store.state.backendeleres+'csoportok/csoport/' + this.id + '/gyakorlatok', this.ujgyakorlat)
         .then(response => {
           if (response.data.ok) {
             delete response.data.ok
             this.csoport.gyakorlatok.push(response.data)
             this.ujgyakorlat.nev = ''
             this.ujgyakorlat.leiras=''
             this.snackbar.szoveg = 'Mentve'
             this.snackbar.megnyit = true
           } else {
             this.snackbar.szoveg = response.data.hiba
             this.snackbar.megnyit = true
           }
           if(response.data.bejelentkezve==false){
             this.kijelentkezes();
           }
         })
     } else {
       this.snackbar.szoveg = 'Adjon meg minden értéket helyesen!'
       this.snackbar.megnyit = true
     }
   },
   gyakorlattorlese: function (gyid, tid) {
     this.axios
       .delete(this.$store.state.backendeleres+'csoportok/gyakorlatok/' + gyid)
       .then(response => {
         if (response.data.ok) {
           this.csoport.gyakorlatok.splice(tid, 1)
         }
         if(response.data.bejelentkezve==false){
             this.kijelentkezes();
           }
       })
   },
   objektumatadas: function (objektum) {
     return JSON.parse(JSON.stringify(objektum))
   },

 },
 mounted () {
   this.csoportfrissitese()
 }
}
</script>
